import styled, { css as styledCSS } from "styled-components";

import * as Dropdown from "ds/Dropdown";
import { makePalette, semiBoldAlias } from "Libs/theme";

const theme = makePalette((palette, props) => ({
  layout_color: {
    default: palette.slate,
    dark: palette.snow
  },
  toggle_color: {
    default: props.isActive ? palette.primary600 : palette.granite,
    dark: props.isActive ? palette.snow : palette.granite,
    contrast: props.isActive ? palette.snow : palette.slate
  },
  toggle_background: {
    default: props.isActive ? palette.primary100 : "transparent",
    dark: props.isActive ? palette.ebonyLight : "transparent",
    contrast: props.isActive ? palette.primary800 : "transparent"
  },
  toggle_background_hover: {
    default: palette.primary100,
    dark: palette.ebonyLight,
    contrast: palette.primary800
  }
}));

export const Layout = styled.div`
  flex-wrap: wrap;
  padding: 4px 8px;
  justify-content: flex-start;
  background-color: var(--menu-snow-background-color, var(--snow));
  border-radius: 2px;
  display: flex;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  color: ${theme.layout_color};
  font-size: 13px;
  line-height: 18px;
  ${semiBoldAlias()};
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-right: 8px;
  position: relative;
`;

export const ListItem = styled.li`
  position: relative;
  display: inline-block;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 2px;
  }
`;

export const Toggle = styled.button.attrs<{
  isActive?: boolean;
  interactive?: boolean;
}>(props => ({
  "aria-pressed": props.isActive ? "true" : null
}))<{ isActive?: boolean; interactive?: boolean }>`
  ${semiBoldAlias()};
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  padding: 2px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  background-color: var(--menu-snow-background-color, var(--snow));
  height: 24px;
  ${({ isActive }) =>
    isActive
      ? "color:var(--timerange-button-color,var(--button-color-primary-600-color,var(--color-primary-600)))"
      : "color:var(--button-granite-color,var(--granite))"};
  text-decoration: none;
  white-space: nowrap;
  transition-duration: 0.25s;
  transition-property: color, background-color;

  :hover {
    background-color: var(
      --section-color-primary-100-background-color,
      var(--color-primary-100)
    );
  }

  ${({ isActive }) =>
    isActive &&
    styledCSS`
      outline: none;
      background-color: var(--timerange-section-background-color,var(--section-color-primary-100-background-color,var(--color-primary-100)));
      svg path{
        stroke: var(--timerange-button-color,var(--button-color-primary-600-color,var(--color-primary-600)));
      }
    `};
`;

export const TimeBlock = styled(Toggle)`
  margin: 0 8px;
`;

export const DropdownTrigger = styled(Dropdown.Trigger)`
  padding: 8px;

  ${Toggle} {
    gap: 8px;
    cursor: pointer;
    min-width: 22px;
    min-height: 22px;
  }
  svg.calendar {
    transform: none;
  }
`;

export const Divider = styled.div`
  position: relative;
  &:after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    background-color: var(--mode-border-neutral-default);
    bottom: -9px;
  }
`;

export const PinIconContainer = styled(Toggle)`
  margin-left: 8px;
`;
